import React from "react";
import { ReactTyped } from "react-typed";
import HeroImage from "../gallery/RSJC_PHOTO_WEBSITE.jpg";

const Hero = () => {
  console.log("Image source at smaller screens:", HeroImage);
  return (
    <section
      className="relative h-[700px] bg-cover bg-center"
      style={{ backgroundImage: `url(${HeroImage})` }}
    >
      <div className="absolute inset-0 bg-black opacity-50"></div>{" "}
      {/* Dark overlay */}
      <div className="absolute inset-0 flex items-center justify-center text-center text-white">
        <div className="text-white">
          <div className=" max-w-[800px] mt-[120px] w-full h-screen mx-auto text-center flex flex-col justify-center">
            <h1 className="uppercase md:text-7xl text-4xl sm:text-5xl font-bold">
              Rising Sun Judo Club
            </h1>
            <p className="mx-auto md:text-4xl sm:text-1xl text-2xl font-bold my-10">
              For{" "}
              <ReactTyped
                strings={["JUDO", "FITNESS", "SELF DEFENCE"]}
                typeSpeed={120}
                backSpeed={140}
                loop
              />{" "}
            </p>
            <p className="mx-auto md:text-2xl sm:text-0.5xl text-1xl my-10 mx-10">
              Rising Sun Judo Club Based in Worthing, For ages 7* and up{" "}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
